export default class ApiHelper {
    public static async ParseDTO<TResponse>(apiCall: () => Promise<TResponse>) : Promise<TResponse> {        
        try {
            return await apiCall();
        } catch (ex) {
            // if this is a known response status code DTO will be in ex...
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((<TResponse>ex) !== undefined) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return <TResponse>ex;
            }
            // if this is an unknown response status code DTO will be in ex.response...
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            else if ((<TResponse>ex.response) !== undefined) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return <TResponse>ex.response;
            } else {
                throw ex;
            }
        }
    }
}